
<template>
  <div>
    <!-- search input  -->
    <div class="form-group">
      <label class="control-label">Categoria:</label>

      <div class="inputSearch">
        <div class="btnDiv" style="">
          <button
            ref="btn"
            type="button"
            @click="openModal"
            :disabled="disabled"
            class="btn btn-primary btn-sm"
          >
            <i class="fa fa-search"></i>
          </button>
        </div>
        <div
          tabindex="0"
          :name="name"
          @blur="validate"
          class="inputDiv"
          @click="openModal"
          :class="[{ disabled: disabled }, { 'is-invalid': getError }]"
        >
          {{ displayedValue }}
        </div>
      </div>

      <div
        v-if="getError"
        style="display: block"
        class="invalid-feedback invalid-feedback-overwrite"
      >
        {{ getError }}
      </div>
    </div>
    <!-- search input  -->
    <!-- search modal  -->
    <b-modal ref="modalSearch" @shown="onShow" hide-footer @hide="onHide">
      <!-- modal-header -->
      <template #modal-header>
        <h5>Selecionar Categoria</h5>
        <!-- open category-form -->
        <b-button
          v-b-tooltip.hover
          class="text-success"
          @click="addCategory()"
          variant="outline-light"
          title="Adicionar nova Categoria"
        >
          <i class="fas fa-plus" />
        </b-button>
        <!-- open category-form -->
      </template>
      <div class="modalSearch">
        <!-- search input -->
        <div class="row">
          <div class="col-md-12">
            <form autocomplete="off" @submit.prevent>
              <input
                autocomplete="false"
                :ref="'searchInput'"
                class="form-control"
                v-model="searchText"
                debounce-events="input"
                v-debounce:400ms="onInput"
              />

              <i
                v-if="isLoading"
                class="fas fa-circle-notch fa-spin text-primary loading-icon"
              />
            </form>
          </div>
        </div>
        <!-- search input -->
        <br />
        <div class="row">
          <div class="col-md-12">
            <table-paginator
              :data="searchResult"
              @pagechange="onSearch($event)"
            >
              <slot />
              <br />
            </table-paginator>
          </div>
        </div>
      </div>
    </b-modal>
    <GlobalEvents
      @keyup.enter="select"
      @keyup.up="backOption"
      @keyup.down="nextOption"
      v-if="listenersConnected"
    />
    <category-form ref="categoryForm" @stored="onSearch($event)" />
  </div>
</template>

<script>
import axios from "axios";
import GlobalEvents from "vue-global-events";
import TablePaginator from "./../../sections/TablePaginator";
import categoryForm from "./../../category/forms/CategoryForm";

export default {
  components: {
    GlobalEvents,
    categoryForm,
    TablePaginator,
  },

  props: {
    name: {},

    form: {},

    value: {},

    alias: {},

    searchResult: {},

    displayedValue: {},

    disabled: {
      default: false,
    },

    isLoading: {
      default: false,
    },
  },

  data: function () {
    return {
      searchText: null,

      listenersConnected: false,

      optionPointer: { pointer: 0 },
    };
  },

  provide: function () {
    return {
      onSelected: this.onSelected,

      optionPointer: this.optionPointer,
    };
  },

  computed: {
    getError() {
      if (this.form !== {} && this.form !== undefined) {
        return this.form.getErrors(this.name);
      }
      return false;
    },
  },

  methods: {
    select() {
      if (this.searchResult.data == undefined) {
        return;
      }

      if (this.searchResult.data[this.optionPointer.pointer] == undefined) {
        return;
      }

      this.$emit(
        "selected",
        this.searchResult.data[this.optionPointer.pointer]
      );

      this.onSelected();
    },

    onInput() {
      this.onSearch();
    },

    onSelected() {
      this.hideModal();
    },

    validate(event) {
      if (this.form != undefined) {
        this.form.validate(this.name);
      }
    },

    openModal() {
      this.searchText = "";

      this.optionPointer.pointer = 0;

      this.$refs.modalSearch.show();
    },

    onShow() {
      this.$refs.searchInput.focus();

      this.listenersConnected = true;
    },

    onHide() {
      this.listenersConnected = false;
    },

    hideModal() {
      this.$refs.modalSearch.hide();
    },

    onSearch(page = 1) {
      this.$emit("search", { text: this.searchText, page: page });

      this.optionPointer.pointer = 0;
    },

    setFocus() {
      this.$refs.btn.focus();
    },

    nextOption() {
      if (this.optionPointer.pointer < this.searchResult.data.length - 1) {
        this.optionPointer.pointer++;
      }
    },

    backOption() {
      if (this.optionPointer.pointer > 0) {
        this.optionPointer.pointer--;
      }
    },

    addCategory() {
      this.$refs.categoryForm.open();
    },
  },
};
</script>

<style>
.loading-icon {
  position: absolute;
  top: 12px;
  right: 22px;
}

.inputSearch {
  display: flex;
}

.inputSearch .btnDiv {
  padding-right: 10px;
}

.inputSearch .inputDiv {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;

  width: 100%;
  display: block;

  border: 1px solid #ced4da;
  border-radius: 0.2rem;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.inputSearch .inputDiv:focus {
  color: #495057;
  background-color: #fff;
  border-color: #2c6fc0;
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(20, 51, 88, 0.25);
}

.inputSearch .inputDiv.disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.inputSearch .inputDiv.is-invalid {
  border-color: #dc3545;
}

.inputSearch .inputDiv.is-invalid:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.activeRow {
  color: #fff;
  background-color: #143358;
}
</style>